/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Lock = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M12 1C14.642 1 16.75 3.265 16.75 6.0232V8.49451H21V23H3V8.49451H7.25V6.0232C7.25 3.265 9.358 1 12 1ZM19.5 9.94506H4.5V21.5494H19.5V9.94506ZM12 11.6374C13.5188 11.6374 14.75 12.828 14.75 14.2967C14.75 15.5138 13.9045 16.5399 12.7506 16.8558L12.75 20.0989H11.25L11.2504 16.8561C10.096 16.5405 9.25 15.5141 9.25 14.2967C9.25 12.828 10.4812 11.6374 12 11.6374ZM12 13.0879C11.3096 13.0879 10.75 13.6291 10.75 14.2967C10.75 14.9643 11.3096 15.5055 12 15.5055C12.6904 15.5055 13.25 14.9643 13.25 14.2967C13.25 13.6291 12.6904 13.0879 12 13.0879ZM12 2.45055C10.2237 2.45055 8.75 4.03404 8.75 6.0232V8.49451H15.25V6.0232C15.25 4.03404 13.7763 2.45055 12 2.45055Z"
                        fill={color}
                    />
                </svg>
        );
    };
